
function animationGsapPhrase() {
    gsap.registerPlugin(ScrollTrigger);

    const selectAll = e => document.querySelectorAll(e);

    const panels = selectAll(".gsap-phrase")

    if (!panels.length) {
      return;
    }

    gsap.to(".gsap-link-item-list", {
      scrollTrigger: {
        trigger: ".gsap-phrase", 
        start: "top 80%",
        toggleActions: "play none none reverse", 
      },
      opacity: 1, 
      duration: 0.5, 
    });
    
    gsap.utils.toArray(".gsap-link-item").forEach((item, i) => {
      gsap.to(item, {
        scrollTrigger: {
          trigger: ".gsap-phrase", 
          start: "top 80%",
          toggleActions: "play none none reverse", 
        },
        opacity: 1,
        y: 0,
        delay: i * 0.2,
        duration: 0.5, 
        ease: "power1.out", 
      });
    });
  }

  animationGsapPhrase();

  // El video/imagen dentro de .gsap-phrase no tiene una altura reservada,
  // así que su carga desplaza el layout y desactualiza los puntos de scroll
  // calculados al inicio. Si al refrescar ya estamos dentro de la sección,
  // ScrollTrigger compara el scroll actual contra una posición "start"
  // desactualizada y nunca dispara el "play", dejando los estilos base.
  window.addEventListener("load", () => ScrollTrigger.refresh());